export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  // Fork: esconde as abas "Todos" e "Não atribuídas", deixando só "Minhas".
  'conversation_only_mine',
];

export const CONVERSATION_ONLY_MINE_PERMISSION = 'conversation_only_mine';

// Permissões de módulos do AstraChat (controle de visibilidade por função).
export const KANBAN_MODULE_PERMISSIONS = [
  'kanban_module',
  'projects_module',
  'appointments_module',
  'disparador_module',
  'email_module',
  'internal_chat_module',
  'flows_module',
  'sequences_module',
  'connections_module',
  'crm_reports_module',
  'calls_module',
];

// Mapa moduleKey (feature_modules) → permissão de função
export const KANBAN_MODULE_PERMISSION_BY_KEY = {
  kanban: 'kanban_module',
  projects: 'projects_module',
  appointments: 'appointments_module',
  disparador: 'disparador_module',
  email: 'email_module',
  internal_chat: 'internal_chat_module',
  flows: 'flows_module',
  sequences: 'sequences_module',
  connections: 'connections_module',
  crm_reports: 'crm_reports_module',
  calls: 'calls_module',
};

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
